'use client'

import { AppFooter } from '@/components/layout/app-footer'
import { SafeInsightsLogo } from '@/components/layout/svg/si-logo'
import { MAIN_CONTENT_PROPS, SIDENAV_BG } from '@/lib/constants'
import { Routes } from '@/lib/routes'
import { AppShell, AppShellHeader, AppShellMain, Button, Group, Paper, Stack, Text, Title } from '@mantine/core'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { NotFoundImage } from '../../public/svg/404-image'
import { fontWeight, semanticColor } from '@/theme/tokens'

export function NotFoundView() {
    const router = useRouter()
    const [loading, setLoading] = useState(false)

    const goHome = () => {
        setLoading(true)
        router.push(Routes.home)
    }

    return (
        <AppShell header={{ height: 70 }} footer={{ height: 60 }}>
            <AppShellHeader bg={SIDENAV_BG} withBorder={false}>
                <Group h="100%" p="md">
                    <SafeInsightsLogo width={250} height={54} />
                </Group>
            </AppShellHeader>

            <AppShellMain
                {...MAIN_CONTENT_PROPS}
                bg={SIDENAV_BG}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                px="md"
            >
                <Paper bg={semanticColor('surface.raised')} p="xxl" radius="sm" maw={600} my={{ base: '1rem', lg: 0 }}>
                    <Stack mb="xxl" ta="center" align="center" gap="0">
                        <NotFoundImage style={{ margin: '0 auto' }} />
                        <Title order={1} fw={800} mt="sm">
                            Page Not Found
                        </Title>
                        <Text size="md" fw={fontWeight.regular} c="grey.6" mt="md">
                            The page you are trying to open does not exist. <br />
                            The page address may have been mistyped, or the page <br /> has been moved to another URL.
                        </Text>
                        <Button size="md" loading={loading} onClick={goHome} mt="xl" style={{ margin: '0 auto' }}>
                            Take me back
                        </Button>
                    </Stack>
                </Paper>
            </AppShellMain>
            <AppFooter isDark />
        </AppShell>
    )
}
